import React from 'react';
import { Image } from '@spotify-internal/encore-web';
import styled from 'styled-components';
import { Dialog } from './Dialog';
const ResponsiveImage = styled(Image) `
  max-width: 100%;
  max-height: 100%;
  width: 100%;
  height: 100%;
  object-fit: scale-down;
`;
export const FullscreenImageOverlay = ({ imageUrl, show, onClose, }) => (React.createElement(Dialog, { show: show, onClose: onClose },
    React.createElement(ResponsiveImage, { alt: "fullscreen image preview", src: imageUrl, onClick: e => e.stopPropagation() })));
